/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TaskType = {
    Search: 'search',
    ForYouFeed: 'for_you_feed',
    Sleep: 'sleep'
} as const;
export type TaskType = typeof TaskType[keyof typeof TaskType];


export function instanceOfTaskType(value: any): boolean {
    for (const key in TaskType) {
        if (Object.prototype.hasOwnProperty.call(TaskType, key)) {
            if (TaskType[key as keyof typeof TaskType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TaskTypeFromJSON(json: any): TaskType {
    return TaskTypeFromJSONTyped(json, false);
}

export function TaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskType {
    return json as TaskType;
}

export function TaskTypeToJSON(value?: TaskType | null): any {
    return value as any;
}

export function TaskTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TaskType {
    return value as TaskType;
}

